
import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';

interface InternalLink {
  title: string;
  url: string;
  description: string;
}

interface InternalLinksProps {
  title: string;
  links: InternalLink[];
  className?: string;
}

export const InternalLinks = ({ title, links, className = "" }: InternalLinksProps) => {
  return (
    <div className={`bg-gray-50 p-6 rounded-lg ${className}`}>
      <h3 className="text-lg font-semibold mb-4 flex items-center">
        {title}
        <ExternalLink className="h-4 w-4 ml-2 text-gray-500" />
      </h3>
      <div className="grid gap-3">
        {links.map((link, index) => (
          <Link
            key={index}
            to={link.url}
            className="block p-3 bg-white rounded border hover:shadow-md transition-shadow"
          >
            <div className="font-medium text-primary hover:text-primary/80">
              {link.title}
            </div>
            <div className="text-sm text-gray-600 mt-1">
              {link.description}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};
